module.exports = __webpack_public_path__ + "static/media/the-ciacon.c6294593.png";